import AntButton from "antd/es/button";
import styled from "styled-components";
import { phoneMinWidth } from "common/NewLook/layout.ts";

const TimeRangeButton = styled(AntButton)<{
  selected?: boolean;
  $size?: string;
}>`
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
  font-size: ${(p) => p.theme.typography.fontSizes.S};
  border-radius: 8px;
  ${(props) =>
    props.selected
      ? `
    background: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.buttonText}!important;
    &:focus {
      background: ${props.theme.colors.primaryBlue}; 
      color: ${props.theme.colors.buttonText};
    }
  `
      : `
    background: inherit;
    color: ${props.theme.colors.primaryText};
    &:focus {
      background: inherit;
      color: black;
    }
  `}
  margin-right: 3px;
  border: none !important;
  box-shadow: none !important;
  &.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover {
    background: ${(p) => p.theme.colors.primaryBlue};
  }

  ${(props) =>
    props.$size === "small" &&
    `
    padding: 1px 6px !important;
    margin-right: 2px;
    height: 30px;
    &.ant-btn-icon-only {
      padding: 1px 0 !important; 
    }
  `}
  ${(props) =>
    props.$size === "medium" &&
    `
    font-size: ${props.theme.typography.fontSizes.M};
    font-weight: ${props.theme.typography.fontWeights.MEDIUM};
    padding: 1px 9px !important;
    margin-right: 2px;
    height: 30px;
    &.ant-btn-icon-only {
      padding: 1px 0 !important; 
    }
  `}
  
  &:hover {
    @media (min-width: ${phoneMinWidth}) {
      background: ${(p) => p.theme.colors.primaryBlue};
      color: ${(p) => p.theme.colors.buttonText} !important;
      opacity: 0.8;
    }
  }

  ${(props) =>
    props.type === "default" &&
    `
     background: inherit;
     color: ${props.theme.colors.secondaryText}!important;
     @media (min-width: ${phoneMinWidth(props)}) {
       &:hover {
          background: inherit !important;
          color: ${props.theme.colors.primaryText}!important;
        }
        &:focus {
          background: inherit;
          color: ${props.theme.colors.primaryText};
        }
      }
    `}
  ${(props) =>
    props.type === "default" &&
    props.selected &&
    `
    color: ${props.theme.colors.primaryText};
    border: 1px solid ${props.theme.colors.primaryText} !important;
    @media (min-width: ${phoneMinWidth(props)}) {
      &:hover {
        opacity: 0.7;
        background: inherit;
      }
      &:focus {
        background: inherit;
        color: ${props.theme.colors.primaryText};
      }
    }
    `}
`;

export default TimeRangeButton;
